import React, { useEffect, useState } from 'react';
import { useNavigate } from "react-router-dom";
import "./employeesList.scss"
import '@fortawesome/fontawesome-free/css/all.min.css';
import Pagination from '../../layout/pagination/Pagination';
import { fetchEmployeesApi } from '../../../api/services/accessManagement-apis';
 
interface EmployeeTableProps {
  onRowClick: (employee: Employee) => void;
}
 
export interface Employee {
  id: number;
  name: string;
  email: string;
  role: string;
  psid: string;
  createdAt: string;
}
 
const EmployeeTable: React.FC<EmployeeTableProps> = ({ onRowClick }) => {
  const [employees, setEmployees] = useState<Employee[]>([]);
  const [query, setQuery] = useState({
    name: "",
    psid: "",
    email: "",
    role: "",
  });
  const [filteredEmployees, setFilteredEmployees] = useState<Employee[]>([]);
  const appName = "product-IT";
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 5;
 
 
  useEffect(() => {
    const fetchEmployees = async () => {
      try {
        const response = await fetchEmployeesApi(appName);
        const processedData = response.map((employee: any) => ({
          ...employee,
          name: `${employee.firstName} ${employee.lastName}`
        }));
        processedData.sort((a: Employee, b: Employee) => new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime());
        setEmployees(processedData);
        setFilteredEmployees(processedData);
      } catch (error) {
        console.error('There was an error fetching the employees!', error);
      }
    };
 
    fetchEmployees();
  }, [appName]);
 
  useEffect(() => {
    let filtered = employees;
    if (query.name) {
      filtered = filtered.filter(employee =>
        employee.name.toLowerCase().includes(query.name.toLowerCase())
      );
    }
    if (query.psid) {
      filtered = filtered.filter(employee =>
        employee.psid.toString().includes(query.psid.toLowerCase())
      );
    }
    if (query.email) {
      filtered = filtered.filter(employee =>
        employee.email.toLowerCase().includes(query.email.toLowerCase())
      );
    }
    if (query.role) {
      filtered = filtered.filter(employee =>
        employee.role.toLowerCase().includes(query.role.toLowerCase())
      );
    }
    setFilteredEmployees(filtered);
  }, [query, employees]);
 

  const handleRowClick = (employee: Employee) => {
    onRowClick(employee);
  };

  const handleQueryChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setQuery({
      ...query,
      [e.target.name]: e.target.value,
    });
  };
 
  const indexOfLastEmployee = currentPage * itemsPerPage;
  const indexOfFirstEmployee = indexOfLastEmployee - itemsPerPage;
  const currentEmployees = filteredEmployees.slice(indexOfFirstEmployee, indexOfLastEmployee);
 
 
  const paginate = (pageNumber: number) => setCurrentPage(pageNumber);
 
  return (
    <div className="projectlistTableContainer">
      <div className="searchInputs">
        <div className="inputContainer">
          <input
            type="text"
            name="name"
            placeholder="Search Name"
            value={query.name}
            onChange={handleQueryChange}
          />
         
          <i className="fa-solid fa-magnifying-glass"></i>
        </div>
        <div className="inputContainer">
          <input
            type="text"
            name="psid"
            placeholder="Search PS No"
            value={query.psid}
            onChange={handleQueryChange}
          />
          <i className="fa-solid fa-magnifying-glass"></i>
        </div>
        <div className="inputContainer">
          <input
            type="text"
            name="email"
            placeholder="Search Email"
            value={query.email}
            onChange={handleQueryChange}
          />
          <i className="fa-solid fa-magnifying-glass"></i>
        </div>
        <div className="inputContainer">
          <input
            type="text"
            name="role"
            placeholder="Search Role"
            value={query.role}
            onChange={handleQueryChange}
          />
          <i className="fa-solid fa-magnifying-glass"></i>
        </div>
      </div>
      <table className="tstylee">
        <thead>
          <tr>
            <td>Name</td>
            <td>PS No</td>
            <td>Email</td>
            <td>Role</td>
          </tr>
        </thead>
        <tbody>
          {currentEmployees.map((employee) => (
            //  <React.Fragment key = {employee.psNo}>
            <tr
              key={employee.psid}
              onClick={() => handleRowClick(employee)}
              style={{ cursor: "pointer" }}
            >
              <td>{employee.name}</td>
              <td>{employee.psid}</td>
              <td>{employee.email}</td>
              <td>{employee.role}</td>
            </tr>
          ))}
        </tbody>
      </table>
      <Pagination
        projectsPerPage={itemsPerPage}
        totalProjects={filteredEmployees.length}
        paginate={paginate}
        currentPage={currentPage}
      />
    </div>
  );
};
 
export default EmployeeTable;